import { type FC } from "react";

import { Checkbox } from "@/shared/components/ui/checkbox";
import { FieldError } from "@/shared/components/ui/FieldError";

import type { FlowCustomComponentProps } from "@/shared/constants/flowTypes";

const CHECKS = [
  { key: "admin_eligibility_age", label: "I'm 18 or older" },
  { key: "admin_eligibility_citizen", label: "I'm a U.S. citizen or permanent resident (green card holder)" },
  { key: "admin_eligibility_felony", label: "I've never been convicted of a felony" },
] as const;

export const AdminEligibilityScreen: FC<FlowCustomComponentProps> = ({
  answers,
  setAnswer,
  errors,
}) => {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-1">
        <p className="font-sans text-xl font-semibold leading-[30px]">
          Make sure you can serve
        </p>
        <p className="text-sm text-secondary tracking-[-0.28px]">
          New York courts require every administrator to meet a few basic rules
        </p>
      </div>

      <div className="flex flex-col gap-4">
        {CHECKS.map(({ key, label }) => (
          <label
            key={key}
            className="flex cursor-pointer items-start gap-3 rounded-lg border border-primary p-4 hover:bg-subtle"
          >
            <Checkbox
              checked={answers[key] === "yes"}
              onCheckedChange={(checked) => setAnswer(key, checked ? "yes" : "")}
            />
            <span className="text-sm">{label}</span>
          </label>
        ))}
      </div>
      <FieldError message={errors?.eligibility} />
    </div>
  );
};
